<div class="container">
    <div class="logo-container">
        <img src="assets/images/logo/logoanvt1.jpg" alt="Logo ANVT">
    </div>

    <h1>Agence Nationale du Volontariat Togo</h1>

    <div class="options-container">
        <div class="option-box">
            <div class="icon-wrapper">
                <i class="fas fa-mobile-alt" style="color:#fec106;"></i>
            </div>
            <h3>Application Mobile</h3>
            <p>Notre application est disponible sur Play Store pour une expérience optimale sur téléphone.</p>
            <a href="https://play.google.com/store/apps/details?id=com.anvt.vnmobile.public&pcampaignid=web_share"
               class="btn"
               target="_blank">
                <img src="../../assets/images/googleplay_download.png"
                     alt="Disponible sur Google Play"
                     class="playstore-icon">
            </a>

        </div>
    </div>

    <!-- Message principal -->
    <div class="support-note warning">
        <div class="support-header">
            <i class="fas fa-exclamation-triangle"></i>
            <h4>Important</h4>
        </div>
        <p>Vous utilisez actuellement le site sur un téléphone, alors qu’il est principalement adapté pour une utilisation sur ordinateur.</p>
        <p>Vous pouvez tout de même continuer à l’utiliser, mais pour éviter tout problème futur, veuillez ajouter votre numéro de téléphone dans votre compte ici sur le web. Cela vous permettra d’accéder facilement au même compte depuis l’application mobile.</p>
        <small class="note-discrete">
            L’application mobile n’est pas encore disponible sur App Store.
        </small>
    </div>
</div>
